/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThoughtspotDataSource
 */
export interface ThoughtspotDataSource {
    /**
     * 
     * @type {string}
     * @memberof ThoughtspotDataSource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtspotDataSource
     */
    name: string;
}

/**
 * Check if a given object implements the ThoughtspotDataSource interface.
 */
export function instanceOfThoughtspotDataSource(value: object): value is ThoughtspotDataSource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ThoughtspotDataSourceFromJSON(json: any): ThoughtspotDataSource {
    return ThoughtspotDataSourceFromJSONTyped(json, false);
}

export function ThoughtspotDataSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThoughtspotDataSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ThoughtspotDataSourceToJSON(json: any): ThoughtspotDataSource {
    return ThoughtspotDataSourceToJSONTyped(json, false);
}

export function ThoughtspotDataSourceToJSONTyped(value?: ThoughtspotDataSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

